import { Fragment } from 'react';
import { useQuery } from 'react-query';
import {
  add,
  parseISO,
  startOfDay,
  endOfDay,
} from 'date-fns';
import { useApp, useFields } from 'hooks';
import { getAllAppointements as getAll } from 'api';
import { getAllAppointements as getAllFake } from 'api/fake';
import Filters from 'components/filters';
import { appointmentBusinessTypes } from 'constants/appointments';
import AppointmentItem from 'components/appointments/appointment-item';
import AppointmentLoader from 'components/appointments/appointment-loader';
import ListPlaceholder from 'components/ui-kit/list-placeholder';
import * as S from './styles';

const startOfToday = startOfDay(new Date());
const yesterday = add(startOfToday, { days: -1 });
const daterange = {
  from: add(yesterday, { days: -30 }),
  to: endOfDay(yesterday),
};

export default function PastList() {
  const { portal, appointment, isPreviewMode } = useApp();
  const { fields, handleClickChange, handleChange } = useFields({
    type: 'all',
    daterange: [daterange.from, daterange.to],
  });

  const getAllAppointements = isPreviewMode ? getAllFake : getAll;

  const { data, isLoading, isFetching } = useQuery(
    [
      'appointments',
      portal?.id,
      {
        from: fields.daterange[0].toISOString(),
        to: fields.daterange[1].toISOString(),
        type: appointmentBusinessTypes[fields.type],
      },
    ],
    getAllAppointements,
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!portal?.id,
    },
  );

  const renderContent = () => {
    if (isLoading || isFetching) {
      return <AppointmentLoader />;
    }

    if (!data?.data || !data?.data.length) {
      return <ListPlaceholder message="No past appointments" />;
    }

    return (
      <S.List>
        {data?.data && data?.data.map((item, index) => (
          <S.ListItem key={`${item.id}-${item.start || ''}-${String(index)}`}>
            <AppointmentItem
              id={item.id}
              title={item.title}
              type={item.businessEntityType}
              address={item.serviceAddress}
              unitNumber={item.unitNumber}
              totalAmount={item.totalAmount}
              date={parseISO(item.start)}
              endDate={item.end ? parseISO(item.end) : null}
              isAllDay={item.isAllDay}
              isCompact={appointment.isCompact}
              employees={item.employees}
              invoice={item.invoiceSent}
              invoiceId={item.invoiceId}
              status={item.status}
              variant="row"
            />
          </S.ListItem>
        ))}
      </S.List>
    );
  };

  return (
    <>
      <Filters
        fields={fields}
        handleClickChange={handleClickChange}
        handleChange={handleChange}
        daterange={{
          maxDate: new Date(),
        }}
        select={{
          options: [
            { label: 'All Types', value: 'all' },
            { label: 'Job', value: 'job' },
            { label: 'Estimate', value: 'estimate' },
            { label: 'Visit', value: 'visit' },
          ],
          name: 'type',
          label: 'Type',
        }}
        showViewToggle
      />
      {renderContent()}
    </>
  );
}
